import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

export function LoginRedirect({ withReturnTo }) {
  const location = useLocation()

  useEffect(() => {
    const url = new URL(window.location.origin)
    url.pathname = '/auth/login'

    if (withReturnTo) {
      url.search = new URLSearchParams({
        returnTo: location.pathname + location.search,
      })
    }

    window.history.pushState({}, '', url.toString())
  }, [withReturnTo, location])

  return null
}

LoginRedirect.defaultProps = {
  withReturnTo: true,
}

LoginRedirect.propTypes = {
  withReturnTo: PropTypes.bool,
}
